import mutations from './mutations'
// import actions from './actions'

const state = {
    szyzreleaseid: [],  	//作业预览发布作业的数据
    sfchapterid: [], //章节id
    szyzStatus: 1,//素质驿站首页
};


export default {
    state,
    mutations
}